/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : ThankYou
* @file : ThankYou.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of ThankYou
*
* Created on : 12-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import ThankYouService from '../../services/ThankYouService/ThankYouService';
import Translation from '../../language/Translation';

class ThankYou extends React.Component
{
	constructor(props)
	{
		
		super(props);
        this.translation = new Translation();
		this.state = {
			user:{
				'email':'',
				'first_name':'',
				'last_name':''
			},
            redirect:0,
            fields: {},
            errors: {},
            player_i:2,
            appendHtml:[''],
            translation:{
                'thankyou_v1':this.translation.getText('thankyou_v1'),
                'thankyou_v2':this.translation.getText('thankyou_v2'),
                'thankyou_v3':this.translation.getText('thankyou_v3'),
                'thankyou_v4':this.translation.getText('thankyou_v4'),
                'thankyou_v5':this.translation.getText('thankyou_v5'),
                'thankyou_v6':this.translation.getText('thankyou_v6'),
                'thankyou_v7':this.translation.getText('thankyou_v7'),
                'thankyou_v8':this.translation.getText('thankyou_v8'),
                'thankyou_v9':this.translation.getText('thankyou_v9'),
                'thankyou_v10':this.translation.getText('thankyou_v10'),
                'thankyou_v11':this.translation.getText('thankyou_v11'),
                'thankyou_v12':this.translation.getText('thankyou_v12'),
                'thankyou_v13':this.translation.getText('thankyou_v13'),
            }
		}

		this.thankYouService = new ThankYouService();
        //this.addMore = this.addMore.bind(this);
        
	}

    renderRedirect() {
    if (this.state.redirect===1) {
        return <Redirect to='/play-again' />
    }
    }

	componentDidMount()
	{
		this.thankYouService.getUserRecord().then(response=>{
			if(response.status==='1')
			{
				let user = {'first_name':response.user_data.first_name,
							'last_name':response.user_data.last_name,
							'email':response.user_data.email,
                            'name':response.user_data.first_name+' '+response.user_data.last_name
						};
				this.setState({fields:user});
			}
		});
	}

    addMore()
    {
        let html = this.state.appendHtml;
        var player1 = parseInt(this.state.player_i)+parseInt(1);
        var player2 = parseInt(this.state.player_i)+parseInt(2);
        var onChangeName1 = this.handleChange.bind(this, "data."+player1+".name");
        var onChangeName2 = this.handleChange.bind(this, "data."+player2+".name");
        var onChangeEmail1 = this.handleChange.bind(this, "data."+player1+".email");
        var onChangeEmail2 = this.handleChange.bind(this, "data."+player2+".email");

        html.push(
            <React.Fragment>
                <div class="form-row">
        <div class="form-group col-md-12 col-lg-6">
        <div class="row">
        <div class="col-md-3 col-lg-4">
        <label htmlFor="Name">{this.state.translation.thankyou_v8}</label>
        </div>
        <div class="col-md-9 col-lg-8">
        <input type="text" class="form-control" id="name" onChange={onChangeName1} placeholder="Vorname Name"/>
        </div>
        </div>
        </div>
        <div class="form-group col-md-12 col-lg-6">
        <div class="row">
        <div class="col-md-3 col-lg-4">
        <label htmlFor="Email">Email</label>
        </div>
        <div class="col-md-9 col-lg-8">
        <input type="text" class="form-control" id="email" onChange={onChangeEmail1} placeholder="Email"/>
        </div>
        </div>
        </div>
        </div>
        <hr/>
        <div class="form-row">
        <div class="form-group col-md-12 col-lg-6">
        <div class="row">
        <div class="col-md-3 col-lg-4">
        <label htmlFor="Name">{this.state.translation.thankyou_v8}</label>
        </div>
        <div class="col-md-9 col-lg-8">
        <input type="text" class="form-control" id="name" onChange={onChangeName2} placeholder="Vorname Name"/>
        </div>
        </div>
        </div>
        <div class="form-group col-md-12 col-lg-6">
        <div class="row">
        <div class="col-md-3 col-lg-4">
        <label htmlFor="Email">Email</label>
        </div>
        <div class="col-md-9 col-lg-8">
        <input type="text" class="form-control" id="email" onChange={onChangeEmail2} placeholder="Email"/>
        </div>
        </div>
        </div>
        </div>
        <hr/>
            </React.Fragment>
        );
  
        this.setState({'player_i':player2});
        
    }

    sendDetails(e)
    {
        e.preventDefault();
        if(this.handleValidation()){
            $("#btnSubmit").attr("disabled", true);
            this.thankYouService.setChallenge(this.state.fields).then(response=>{
                $('#btnSubmit').removeAttr("disabled");
                if(response.status==='1')
                {
                    this.setState({redirect:1});
                }
           });
           
        }else{
           
        }
    }
    handleValidation(){
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if(!fields["name"]){
           formIsValid = false;
           errors["name"] = "Bitte ausfüllen";
        }
        

        /*if(typeof fields["name"] !== "undefined"){
           if(!fields["name"].match(/^[a-zA-Z]+$/)){
              formIsValid = false;
              errors["name"] = "Only letters";
           }        
        }*/

        //Email
        if(!fields["email"]){
           formIsValid = false;
           errors["email"] = "Bitte ausfüllen";
        }

        if(typeof fields["email"] !== "undefined"){
           let lastAtPos = fields["email"].lastIndexOf('@');
           let lastDotPos = fields["email"].lastIndexOf('.');

           if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
              formIsValid = false;
              errors["email"] = "E-Mail Format ungültig";
            }
       } 


       if(!fields["data.0.name"]){
           formIsValid = false;
           errors["data.0.name"] = "Bitte ausfüllen";
        } 

        if(!fields["data.0.email"]){
           formIsValid = false;
           errors["data.0.email"] = "Bitte ausfüllen";
        }

        if(typeof fields["data.0.email"] !== "undefined"){
           let lastAtPos = fields["data.0.email"].lastIndexOf('@');
           let lastDotPos = fields["data.0.email"].lastIndexOf('.');

           if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["data.0.email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["data.0.email"].length - lastDotPos) > 2)) {
              formIsValid = false;
              errors["data.0.email"] = "E-Mail Format ungültig";
            }
       }

       this.setState({errors: errors});
       return formIsValid;
   }
    handleChange(field, e){     
       // e.preventDefault();    
        let fields = this.state.fields;
        if(field.indexOf('data') !== -1)
        {
        var newField = field.split(".");
        console.log(newField[0]);
        if(newField[0] in fields)
        {
            if(newField[1] in fields[newField[0]])
            {
                if(newField[2] in fields[newField[0]][newField[1]])
                {
                    fields[newField[0]][newField[1]][newField[2]] = e.target.value;
                    fields[field] = e.target.value;
                }
                else
                {
                    fields[newField[0]][newField[1]][newField[2]] = '';
                    fields[newField[0]][newField[1]][newField[2]] = e.target.value;
                    fields[field] = e.target.value;
                }
            }   
            else
            {
                fields[newField[0]][newField[1]] = {};  
                fields[newField[0]][newField[1]][newField[2]] = '';
                fields[newField[0]][newField[1]][newField[2]] = e.target.value;
                fields[field] = e.target.value;
            }
        }
        else {
            fields[newField[0]] = {};
            fields[newField[0]][newField[1]] = {};
            fields[newField[0]][newField[1]][newField[2]] = '';
            fields[newField[0]][newField[1]][newField[2]] = e.target.value;
            fields[field] = e.target.value;
        }
    }
    else
    {
        fields[field] = e.target.value; 
    }
        this.setState({fields});
    }

	render()
	{
		let user = this.state.user;
		return (
			<React.Fragment>
            {this.renderRedirect()}
			<div className="content-box-area">
      <div className="progress-bar large-Width"></div>      
        <div className="default-heading fontSize margbotmNone">
          <h2>{this.state.translation.thankyou_v1}</h2>
        </div>        
        <div className="paragraph-area text-center marbotm">
        <p>{this.state.translation.thankyou_v2}</p>        
        <p>{this.state.translation.thankyou_v3}{this.state.translation.thankyou_v4}</p>
        </div> 
        <div className="form-area">
        <div className="row justify-content-center">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">                
        <form onSubmit= {this.sendDetails.bind(this)}>
        <div className="form-row">
        <div className="form-group col-md-12 col-lg-6">
            <div className="row">
                <div className="col-md-3 col-lg-4">
                <label htmlFor="Ihrname">{this.state.translation.thankyou_v5}</label>
                </div>
                <div className="col-md-9 col-lg-8">
                <input type="text" className="form-control" id="Ihrname" ref="name" onChange={this.handleChange.bind(this, "name")} defaultValue={this.state.fields["name"]} placeholder="Vorname Nachname"/>
                <span style={{color: "red"}}>{this.state.errors["name"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12 col-lg-6">
           <div className="row">
            <div className="col-md-3 col-lg-4">
            <label htmlFor="Ihremail">{this.state.translation.thankyou_v6} </label>
            </div>
            <div className="col-md-9 col-lg-8">
            <input type="text" className="form-control" id="Ihremail" ref="email" onChange={this.handleChange.bind(this, "email")} defaultValue={this.state.fields["email"]} placeholder="E-Mail Adresse (name@email.ch)"/>
            <span style={{color: "red"}}>{this.state.errors["email"]}</span>
            </div>
            </div>
        </div>        
        </div>
        <div className="form-row">
        <div className="col-md-12 default-heading margtopbottom text-left">
          <h5><strong>{this.state.translation.thankyou_v7}</strong></h5>
        </div> 
        <div className="form-group col-md-12 col-lg-6">
        <div className="row">
            <div className="col-md-3 col-lg-4">
            <label htmlFor="Name">{this.state.translation.thankyou_v8}</label>
            </div>
            <div className="col-md-9 col-lg-8">
            <input type="text" className="form-control" id="name_0" ref="data.0.name" onChange={this.handleChange.bind(this, 'data.0.name')} defaultValue={this.state.fields["data.0.name"]} placeholder="Vorname Name"/>
            <span style={{color: "red"}}>{this.state.errors["data.0.name"]}</span>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12 col-lg-6">
        <div className="row">
            <div className="col-md-3 col-lg-4">
            <label htmlFor="E-Mail">{this.state.translation.thankyou_v9}</label>
            </div>
            <div className="col-md-9 col-lg-8">
            <input type="text" className="form-control" id="email_0" ref="data.0.email" onChange={this.handleChange.bind(this, 'data.0.email')} defaultValue={this.state.fields["data.0.email"]} placeholder="E-Mail"/>
            <span style={{color: "red"}}>{this.state.errors["data.0.email"]}</span>
            </div>
        </div>
        </div>
        </div>
        <hr/>
        <div className="form-row">        
        <div className="form-group col-md-12 col-lg-6">
        <div className="row">
            <div className="col-md-3 col-lg-4">
            <label htmlFor="Name">{this.state.translation.thankyou_v8}</label>
            </div>
            <div className="col-md-9 col-lg-8">
            <input type="text" className="form-control" id="name_1" ref="data.1.name" onChange={this.handleChange.bind(this, 'data.1.name')} placeholder="Vorname Name"/>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12 col-lg-6">
        <div className="row">
            <div className="col-md-3 col-lg-4">
            <label htmlFor="E-Mail">{this.state.translation.thankyou_v9}</label>
            </div>
            <div className="col-md-9 col-lg-8">
            <input type="text" className="form-control" id="email_1" ref="data.1.email" onChange={this.handleChange.bind(this, 'data.1.email')} placeholder="E-Mail"/>
            </div>
        </div>
        </div>
        </div>
        <hr/>
        <div id="morePlayer">{this.state.appendHtml}</div>
        <div className="form-row">
        <div className="form-group col-md-6 col-sm-12 thankyou-addmore">     
          <Link to="#" className="add-row-folder" onClick={this.addMore.bind(this)}>{this.state.translation.thankyou_v10}</Link>
        </div>
        <div className="form-group col-md-6 col-sm-12 thankyou-donate">     
          <Link to="/play-again" className="new-link">{this.state.translation.thankyou_v11}</Link>
        </div>
        <div className="form-group col-md-12 text-center">
            <div className="row">
                <div className="form-group col-md-12">
                <button type="submit" className="btn btn-primary btn-large" id="btnSubmit">{this.state.translation.thankyou_v12}</button>
                </div>
            </div>
        </div>
        </div>        
        </form>
        </div>        
        </div> 
        </div>
        <div className="text-center">     
          <a href="https://www.biovision.ch/datenschutz/" className="link-live" target="_blank">{this.state.translation.thankyou_v13}</a>
        </div>
      </div>
      </React.Fragment>
		)
	}
}

export default ThankYou;
